import { errorToast } from '@/js/components/toast';

const init = () => {
  const LAYOUTS = {
    GRID: 'grid',
    TABLE: 'table',
  };
  const lsLayoutKey = 'wild-project-layout';
  const loadMoreButtons = document.querySelectorAll('[data-projects-loadmore]');
  const sortButtons = document.querySelectorAll('[data-sort-field]');
  const switchLayoutButtons = document.querySelectorAll('.js-projects-layout');
  const projectsGridContainer = document.getElementById('js-projects-grid-container');
  const projectsGrid = document.getElementById('js-projects-grid');
  const projectsTableContainer = document.getElementById('js-projects-table-container');
  const projectsTableBody = document.getElementById('js-projects-table-body');

  // Toggle default layout from LS
  try {
    const layout = window.localStorage.getItem(lsLayoutKey);
    if (layout === LAYOUTS.TABLE) {
      projectsGridContainer.classList.toggle('hidden');
      projectsTableContainer.classList.toggle('hidden');
    }
  } catch (e) {
    // Ignore LS errors
  }

  loadMoreButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const { layout, nextPage, url, totalPages, sortField, sortOrder } = JSON.parse(button.dataset.projectsLoadmore);
      const isLoading = button.classList.contains('is-loading');
      const elementsLayout = layout === LAYOUTS.GRID ? LAYOUTS.GRID : LAYOUTS.TABLE;
      const targetPlacement = elementsLayout === LAYOUTS.GRID ? projectsGrid : projectsTableBody;
      let isActive = true;

      if (isLoading) {
        return;
      }

      button.classList.add('is-loading');
      button.disabled = true;

      sortButtons.forEach((b) => {
        b.disabled = true;
      });

      const urlParams = new URLSearchParams();
      urlParams.append('page', nextPage);
      urlParams.append('sort', sortField || 'lft');
      urlParams.append('order', sortOrder || 'asc');

      fetch(`${url}/ajax-${elementsLayout}?${urlParams}`)
        .then((res) => {
          if (res.ok) {
            return res.text();
          }

          throw new Error('Server error');
        })
        .then((data) => {
          targetPlacement.insertAdjacentHTML('beforeend', data);

          button.dataset.projectsLoadmore = JSON.stringify({
            ...JSON.parse(button.dataset.projectsLoadmore),
            nextPage: nextPage + 1,
          });

          // Keep disabled state if there are no more pages left
          if ((nextPage + 1) > totalPages) {
            isActive = false;
          }
        })
        .catch(() => {
          errorToast('Error loading projects. Please try again.');
        })
        .finally(() => {
          setTimeout(() => {
            if (isActive) {
              button.disabled = false;
            } else {
              button.classList.add('opacity-0');
            }
            button.classList.remove('is-loading');

            sortButtons.forEach((b) => {
              b.disabled = false;
            });
          }, 1500);
        });
    });
  });

  sortButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      sortButtons.forEach((b) => {
        b.classList.remove('is-active');
      });
      button.classList.add('is-active');

      const sortField = button.dataset.sortField;
      const sortOrder = button.dataset.sortOrder;

      // Clean table
      projectsTableBody.innerHTML = '';
      // Change button state
      if (sortOrder === 'desc') {
        button.classList.remove('is-asc');
        button.dataset.sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
      }
      if (sortOrder === 'asc') {
        button.classList.add('is-asc');
        button.dataset.sortOrder = 'desc';
      }

      // Fetch
      const tableLoadMoreBtn = document.querySelector('[data-projects-loadmore*="table"]');
      tableLoadMoreBtn.disabled = false;
      tableLoadMoreBtn.classList.remove('opacity-0');
      tableLoadMoreBtn.dataset.projectsLoadmore = JSON.stringify({
        ...JSON.parse(tableLoadMoreBtn.dataset.projectsLoadmore),
        nextPage: 1,
        sortField,
        sortOrder,
      });
      tableLoadMoreBtn.click();
    });
  });

  switchLayoutButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const activeLayout = projectsGridContainer.classList.contains('hidden') ? LAYOUTS.GRID : LAYOUTS.TABLE;
      projectsGridContainer.classList.toggle('hidden');
      projectsTableContainer.classList.toggle('hidden');

      try {
        window.localStorage.setItem(lsLayoutKey, activeLayout);
      } catch (e) {
        // Ignore LS errors
      }

      button.firstElementChild?.classList.toggle('opacity-0');
      button.lastElementChild?.classList.toggle('opacity-0');
    });
  });
};

export default {
  init,
};
